import { searchPolicySuggestionsDictionary } from "constants/policy";
import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPagePolicy } from "hooks/useAnalytics/pages/policy";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    trackAnalytics: useAnalytics({ page: AnalyticsPagePolicy.PoliciesList }),
    searchSuggestionsDictionary: searchPolicySuggestionsDictionary,
  })(props);
};

export default useCellFilterAction;
